import { createAction, props } from '@ngrx/store';
import {
    Note,
    NoteCreate
} from 'src/app/workforce-disruption/shared/models/note-model';

export const loadNotes = createAction('[WDP CANDIDATE PROFILE COMPONENT NOTES] Load Notes');
export const loadNotesSuccess = createAction(
    '[WDP API] Load Notes Successfully',
    props<{
        notes: Note[];
    }>()
);

export const loadNotesFailure = createAction('[WDP API] Load Notes Failure', props<{ error: unknown }>());

export const addNote = createAction(
    '[WDP CANDIDATE PROFILE COMPONENT NOTES] Add Note',
    props<{ newNote: NoteCreate }>()
);

export const addNotesSuccess = createAction('[WDP API] Add Notes Successfully', props<{ returnNote: Note }>());

export const addNotesFailure = createAction('[WDP API] Add Notes Failure', props<{ error: unknown }>());
